export default {"src":"/_next/static/media/evolution.886558b0.svg","height":262,"width":262,"blurWidth":0,"blurHeight":0};